import { useCallback, useEffect, useRef, useState } from "react";
import { useAuth } from "../contexts/AuthCtx";
import { useOnClickOutside } from "../hooks/useOnClickOutside";
import { GoogleReCaptchaProvider, GoogleReCaptcha, useGoogleReCaptcha } from 'react-google-recaptcha-v3';
import AuthService from "../api/auth";

export function CookiesDialog({ hasScolled }) {

  const authCtx = useAuth();

  useEffect(() => {
    setTimeout(() => {
      authCtx.setShowCookieAccepted();
    }, 2000);
  }, [])

  return (
    <>
      <div className={("alert-cookies")}>
        <div className="alert-inner">
          <p>We are using cookies to provide you best experience.</p>
          {/* <a href="#">Learn more</a> */}
        </div>
      </div>
    </>
  );
}

export function JoinNewsletterDialog() {

  const [loading, setLoading] = useState(0);  // initial = 0, loading = 1, success = 2, error = 3

  const [token, setToken] = useState("");
  const [refreshReCaptcha, setRefreshReCaptcha] = useState(false);
  const { executeRecaptcha } = useGoogleReCaptcha();

  const nameRef = useRef(null);
  const emailRef = useRef(null);


  const authCtx = useAuth();

  const dialogRef = useRef(null);

  const handleSubmitForm = (e) => {
    //   // setLoading(1);
    e.preventDefault();
    // window.alert("Submitted token :: ", token);
    //   setRefreshReCaptcha(!refreshReCaptcha);
    setLoading(1);
    AuthService.joinNewsletter({
      name: nameRef.current.value,
      email: emailRef.current.value
    }, {}).then((r) => {
      if(r && r.status === 200) {
        setLoading(2);
      }
      else
      {
        setLoading(3);
      }
    })
  }

  // const handleSubmitForm = useCallback(
  //   (e) => {
  //     console.log("XXX")
  //     e.preventDefault();
  //     if (!executeRecaptcha) {
  //       console.log("Execute recaptcha not yet available");
  //       return;
  //     }
  //     executeRecaptcha("enquiryFormSubmit").then((gReCaptchaToken) => {
  //       console.log(gReCaptchaToken, "response Google reCaptcha server");
  //       // submitEnquiryForm(gReCaptchaToken);
  //     });
  //   },
  //   [executeRecaptcha]
  // );

  const setTokenFunc = (getToken) => {
    console.log("G :: ", getToken)
    setToken(getToken);
  };


  useOnClickOutside(dialogRef, (e) => {
    console.log("CLICKED OUTSIDE.")
    authCtx.toggleShowNewsletterDialog(false);
  }, (e) => {

  }, authCtx.open_popups.show_join_newsletter === true);

  useEffect(() => {
    if(loading === 2) {
      setTimeout(() => {
        authCtx.toggleShowNewsletterDialog(false);
      }, 3000);
    }
    else if(loading === 3) {
      setTimeout(() => {
        setLoading(0);
      }, 3000);
    }
  }, [loading])

  const handleCloseDialog = (e) => {
    authCtx.toggleShowNewsletterDialog(false);
  }

  return (
    <>
      <div className="dialog-backdrop">
        <div ref={dialogRef} className="dialog h-auto">
          <div className="dialog-inner">
            <div className="section sec-green">
              <h1>Join in 11k+ our newsletter to get our blog updates, news & much more.</h1>
            </div>
            <div className="section sec-green-content">
              <div className="inner-content">
                <form className="form" onSubmit={handleSubmitForm}>
                  <div className="field">
                    <div className="label">Name/Company (optional)</div>
                    <div className="control">
                      <input ref={nameRef} type="text" />
                    </div>
                  </div>
                  <div className="field">
                    <div className="label">Email</div>
                    <div className="control">
                      <input ref={emailRef} name="email" required type="email" />
                    </div>
                  </div>
                  <div className="field">
                    <div className="control">
                      <button disabled={loading !== 0} type="submit">{loading === 1 ? "Joining..." : loading === 2 ? "Joined, Thank you!" : loading === 3 ? "Failed to submit." : "Join"}</button>

                      {/* <button disabled={[1, 2].includes(loading) > -1} type="submit">Submit</button> */}
                    </div>
                    <div className="control mt-10 mb-10 only-mobile-view">
                      <button type="reset" onClick={handleCloseDialog} className="secondary">Close</button>
                    </div>
                    <div className="desc">
                      <p>By submitting the form you agree to our terms & service and consent us to reach you back for the same.</p>
                    </div>
                  </div>
                  {/* <GoogleReCaptchaProvider scriptProps={{
                    async: false,
                    defer: false,
                    appendTo: "head",
                    nonce: undefined,
                  }} reCaptchaKey={"6LeRSPcpAAAAALwGXWnQLkah0VmKh2LXxqeKyyj9"}>
                    <GoogleReCaptcha onVerify={setTokenFunc} refreshReCaptcha={refreshReCaptcha} />
                  </GoogleReCaptchaProvider> */}
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export function StartProjectDialog() {

  const [loading, setLoading] = useState(0);  // initial = 0, loading = 1, success = 2, error = 3
  const authCtx = useAuth();
  const { executeRecaptcha } = useGoogleReCaptcha();

  const dialogRef = useRef(null);

  const nameRef = useRef(null);
  const emailRef = useRef(null);
  const mobileRef = useRef(null);
  const descriptionRef = useRef(null);

  const handleSubmitForm = (e) => {
    setLoading(1);
    e.preventDefault();
    AuthService.sendQuote({
      name: nameRef.current.value,
      email: emailRef.current.value,
      phone: mobileRef.current.value,
      description: descriptionRef.current.value
    }, {}).then((r) => {
      if(r && r.status === 200) {
        setLoading(2);
      }
      else
      {
        setLoading(3);
      }
    })
  }

  // const handleSubmitForm = useCallback(
  //   (e) => {
  //     e.preventDefault();
  //     if (!executeRecaptcha) {
  //       console.log("Execute recaptcha not yet available");
  //       return;
  //     }
  //     executeRecaptcha("enquiryFormSubmit").then((gReCaptchaToken) => {
  //       console.log(gReCaptchaToken, "response Google reCaptcha server");
  //       submitEnquiryForm(gReCaptchaToken);
  //     });
  //   },
  //   [executeRecaptcha]
  // );

  const submitEnquiryForm = (token) => {
    // call api with token
  }

  useOnClickOutside(dialogRef, (e) => {
    authCtx.setGetQuote(false);
    authCtx.toggleShowStartProjectDialog(false);
  }, (e) => {

  }, (authCtx.open_popups.show_start_project === true || authCtx.force_open_get_quote === true));

  const handleCloseDialog = (e) => {
    authCtx.setGetQuote(false);
    authCtx.toggleShowStartProjectDialog(false);
  }

  useEffect(() => {
    if(loading === 2) {
      setTimeout(() => {
        authCtx.setGetQuote(false);
        authCtx.toggleShowStartProjectDialog(false);
      }, 3000);
    }
    else if(loading === 3) {
      setTimeout(() => {
        setLoading(0);
      }, 3000);
    }
  }, [loading])

  return (
    <>
      <div className="dialog-backdrop">
        <div ref={dialogRef} className="dialog">
          <div className="dialog-inner">
            <div className="section sec-green">
              <h1>Leave us a note we will be in touch with you soon.</h1>
            </div>
            <div className="section sec-green-content">
              <div className="inner-content">

                <form className="form" onSubmit={handleSubmitForm}>
                  <div className="field">
                    <div className="label">Name/Company</div>
                    <div className="control">
                      <input ref={nameRef} type="text" required />
                    </div>
                  </div>
                  <div className="field">
                    <div className="label">Email</div>
                    <div className="control">
                      <input ref={emailRef} name="email" required type="email" />
                    </div>
                  </div>
                  <div className="field">
                    <div className="label">Mobile</div>
                    <div className="control">
                      <input ref={mobileRef} name="mobile" type="mobile" />
                    </div>
                  </div>
                  <div className="field">
                    <div className="label">Describe</div>
                    <div className="control">
                      <textarea ref={descriptionRef} name="describe" required></textarea>
                    </div>
                  </div>
                  <div className="field">
                    <div className="control">
                      <button disabled={loading !== 0} type="submit">{loading === 1 ? "Submitting..." : loading === 2 ? "Submitted, We'll contact you back soon." : loading === 3 ? "Submitted, We'll contact you back soon." : "Submit"}</button>
                    </div>
                    <div className="control mt-10 mb-10 only-mobile-view">
                      <button type="reset" onClick={handleCloseDialog} className="secondary">Close</button>
                    </div>
                    <div className="desc">
                      <p>By submitting the form you agree to our terms & service and consent us to reach you back for the same.</p>
                    </div>
                  </div>
                </form>

              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}


export function CookiesPopups({ hasScrolled }) {
  const authCtx = useAuth();
  return (
    <>
      {authCtx.open_popups.show_join_newsletter && <JoinNewsletterDialog />}
      {/* {authCtx.open_popups.show_start_project && <GoogleReCaptchaProvider scriptProps={{
        async: false,
        defer: false,
        appendTo: "head",
        nonce: undefined,
      }} reCaptchaKey={"6LeRSPcpAAAAALwGXWnQLkah0VmKh2LXxqeKyyj9"}><StartProjectDialog /></GoogleReCaptchaProvider>} */}
      {authCtx.open_popups.show_start_project || authCtx.force_open_get_quote && <StartProjectDialog />}
    </>
  );
}